import React, { useContext } from "react";
import {
  AppStateContext,
  BanjosInput,
  Dropzone,
  onShowHideLogoElement,
} from "../../../shared";

export const EditWeAreAvailable = () => {
  const { appState, appScopeDispatch } = useContext(AppStateContext);
  const { index, storeTemplate } = appState;
  const { weAreAvailable } = storeTemplate;
  const onChange = (e) => {
    const { name, value } = e.target;
    appScopeDispatch({
      type: "ON_WE_ARE_AVAILABLE_CHANGE",
      payload: {
        name,
        value,
      },
    });
  };

  const onUpload = (url) => {
    appScopeDispatch({
      type: "ON_WE_ARE_AVAILABLE_CHANGE",
      payload: {
        name: "logo",
        value: url,
      },
    });
  };

  return (
    <>
      {weAreAvailable[index] && (
        <>
          <BanjosInput
            type="color"
            value={weAreAvailable[index].btnColor}
            label={`Button ${index + 1}`}
            name="btnColor"
            onChange={(e) => onChange(e, index)}
            isHideElement={true}
            isHide={weAreAvailable[index].show}
            onClickHideElement={() =>
              onShowHideLogoElement(appScopeDispatch, "weAreAvailable", index)
            }
          />
          <BanjosInput
            type="text"
            name="link"
            value={weAreAvailable[index].link ?? ""}
            onChange={(e) => onChange(e, index)}
            placeholder="Link"
          />
          <Dropzone onUpload={onUpload} />
        </>
      )}
    </>
  );
};
